import React from 'react'
import { Tabs } from "antd";
import Image from "next/image";
import CommonImage from '../../../common/image/CommonImage';
import { Collapse, Empty, Space } from "antd";
import { FaPlay } from "react-icons/fa";

export default function FaqComponent() {

  return (
    <Space direction="vertical" size={16} className="faq_accordions">

      <Collapse
        accordion
        defaultActiveKey={["1"]}
        style={{ width: "100%", marginBottom: 16 }}
        items={[
          {
            key: "1",
            label: (
              <span className="faq-label"> 
                আমাদের কাজসমূহের উপর আস্থা রেখে ক্লাইন্ট নিয়মিত আমাদের সাথে কাজ করে যাচ্ছেন 
              </span>
            ),
            children: (
              <>
                 <div className="faq-answer-text">
                  এখানে FAQ এর উত্তর/Description লেখা থাকবে। আমাদের কাজসমূহের উপর আস্থা রেখে ক্লাইন্ট নিয়মিত আমাদের সাথে কাজ করে যাচ্ছেন আমাদের কাজসমূহের উপর আস্থা রেখে ক্লাইন্ট নিয়মিত আমাদের সাথে কাজ করে যাচ্ছেন 
                 </div>
              </>
            ),
          },
        ]}
      />
      <Collapse
        accordion
        defaultActiveKey={["2"]}
        style={{ width: "100%", marginBottom: 16 }}
        items={[
          {
            key: "1",
            label: (
              <span className="faq-label"> 
                আমাদের কাজসমূহের উপর আস্থা রেখে ক্লাইন্ট নিয়মিত আমাদের সাথে কাজ করে যাচ্ছেন 
              </span>
            ),
            children: (
              <>
                <div className="faq-answer-text">
                  এখানে FAQ এর উত্তর/Description লেখা থাকবে। আমাদের কাজসমূহের উপর আস্থা রেখে ক্লাইন্ট নিয়মিত আমাদের সাথে কাজ করে যাচ্ছেন আমাদের কাজসমূহের উপর আস্থা রেখে ক্লাইন্ট নিয়মিত আমাদের সাথে কাজ করে যাচ্ছেন 
                 </div>
              </>
            ),
          },
        ]}
      />



    </Space>
  )
}
